<div class="flex-container gap-8" style="height: 100%">
  <vl-widget-title [text]="'dashboard_ui.ca_par_periode' | trans" [widget]="widget()" [draggable]="true" [filter]="true">
    <ng-content class="drag-handler" select='.drag-handler'></ng-content>
    <vl-widget-period-filters class="filter" [(period)]="period" [(timeScale)]="timeScale" [(comparison)]="comparison"/>
  </vl-widget-title>

  @if (metadata().loading) {
    <div class="overflow-hidden chart-area">
      <div class="flex-row gap-32 align-end">
        <ngx-skeleton-loader count="1" [theme]="{'height': '200px', 'width': '70px', 'background-color': 'var(--color-on-disabled)'}"/>
        <ngx-skeleton-loader count="1" [theme]="{'height': '140px', 'width': '70px', 'background-color': 'var(--color-on-disabled)'}"/>
        <ngx-skeleton-loader count="1" [theme]="{'height': '220px', 'width': '70px', 'background-color': 'var(--color-on-disabled)'}"/>
        <ngx-skeleton-loader count="1" [theme]="{'height': '110px', 'width': '70px', 'background-color': 'var(--color-on-disabled)'}"/>
        <ngx-skeleton-loader count="1" [theme]="{'height': '90px', 'width': '70px', 'background-color': 'var(--color-on-disabled)'}"/>
        <ngx-skeleton-loader count="1" [theme]="{'height': '30px', 'width': '70px', 'background-color': 'var(--color-on-disabled)'}"/>
      </div>
    </div>
  } @else if (data()?.data?.length) {
    <div class="chart-area fade-in">
      <canvas class="w100 h100" #caperiode></canvas>
      <vl-chips class="see-all-chip"
                state="active"
                size="small"
                iconRight="open_in_new"
                (action)="openFullList()"
                matTooltip="Détail des {{ scaleLabelPlural() }} avec top clients et export Excel">
        {{ 'button.see_all' | trans }}
      </vl-chips>
    </div>
  } @else {
    <span class="caption on-disabled">{{ 'list.empty' | trans }}</span>
  }
</div>
